var map = {
	"./ekwana-2-jai.png": 42,
	"./ekwana-2-ruhang.png": 119,
	"./ekwana-jai-2.png": 384,
	"./ekwana-jai.png": 228,
	"./ekwana-ruhang-2.png": 202,
	"./ekwana-ruhang.png": 870,
	"./jai-2.png": 155,
	"./jai.png": 868,
	"./ruhang-2.png": 130,
	"./ruhang.png": 823,
	"./vargeet-2-jai.png": 399,
	"./vargeet-2-ruhang.png": 704,
	"./vargeet-jai-2.png": 957,
	"./vargeet-jai.png": 969,
	"./vargeet-ruhang-2.png": 914,
	"./vargeet-ruhang.png": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 809;